import { SwapOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { ZEntityRow } from "src/pages/EntityFiltersPage/EntityList/types";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { notification } from "antd";
import { DropdownChildButton } from "../buttons/DropdownChildButton";
import { TableStore } from "../tables/TableStore";
import { MassEditModal } from "./MassEditModal";

interface MassEditStore {
  tableStore: TableStore<ZEntityRow, {}> | null;
  attributesMap: Record<ZUid, ZAttribute>;
  typesMap: Record<number, string>;
  currObjId: ZUid | null;
}

interface PropsMassEditButton {
  store: MassEditStore;
}

export const MassEditButton: React.FC<PropsMassEditButton> = observer(
  ({ store }) => {
    const [open, setOpen] = useState(false);

    if (store.currObjId === null || store.tableStore === null) return null;
    const massEditAttrs = Object.values(store.attributesMap).filter(
      (attr) => attr.massReplacement?.isActive,
    );
    const selectedEntitiesIds =
      store.tableStore?.selected.map((entity) => entity.id) || [];
    const disabled = !(massEditAttrs.length && selectedEntitiesIds.length);

    return (
      <>
        <DropdownChildButton
          icon={<SwapOutlined />}
          disabled={disabled}
          onClick={() => setOpen(true)}
        >
          Заменить значение
        </DropdownChildButton>
        {open && (
          <MassEditModal
            attrList={massEditAttrs}
            entitiesIds={selectedEntitiesIds}
            objectId={store.currObjId}
            typesMap={store.typesMap}
            onCancel={() => setOpen(false)}
            onSuccess={() => {
              setOpen(false);
              store.tableStore?.reload();
              notification.success({
                message: "Выполнена массовая замена значений",
              });
            }}
          />
        )}
      </>
    );
  },
);
